import {createQueryKeys} from "../../shared/query/query-keys";

export const serviceFunctionKeys = createQueryKeys("serviceFunctions");

export const serviceFunctionMutationKeys = {
  createServiceFunction: ["serviceFunctions", "mutation", "create-service-function"] as const,
  updateServiceFunction: ["serviceFunctions", "mutation", "update-service-function"] as const,
  deleteServiceFunction: ["serviceFunctions", "mutation", "delete-service-function"] as const,
  restoreServiceFunction: ["serviceFunctions", "mutation", "restore-service-function"] as const,
} as const;
